<template>
  <Modal
    id="ChargeStationImagesEdit"
    width="60%"
    :open="visible"
    @cancel="visible = !visible"
    @ok="submit"
    :title="title"
    :destroyOnClose="true"
  >
    <Row align="middle" justify="center">
      <Col span="18" >
        <Row>
          <Col span="24">
            <Form
              ref="chargeStationImagesForm"
              :model="form"
              layout="vertical"
              :rules="validateRules"
            >
              <Row justify="space-around">
                  <Col span="10">
                    <FormItem :label="$t('chargeStationImages.field.id_cha_poi')" name="idChaPoi">
                        <!--关联表的下拉选择-->
                        <Select
                                v-model:value="form.idChaPoi"
                                :placeholder="$t('chargeStationImages.validate.required.id_cha_poi')"
                                :dropdownStyle="{ zIndex: 9999999950 }"
                        >
                          <SelectOption :key="sk" v-for="(item,sk) in selectList['chargingStationList']" :value="item['idChaPoi']">{{ item['chargeBoxId'] }}</SelectOption>
                        </Select>
                  </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem :label="$t('chargeStationImages.field.url')" ref="url" name="url">
                      <UploadImage
                          :url="form.url"
                          @new_image_url="(value) => {
                            this.$refs.url.clearValidate()
                            this.form.url = value
                         }"
                          ref="upload_url"
                      />
                  </FormItem>
                  </Col>
                  <!-- <Col span="10">
                    <FormItem :label="$t('chargeStationImages.field.upload_time')" name="uploadTime">
                      <DatePicker show-time valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.uploadTime" :popupStyle="{ zIndex: 9999999950 }"></DatePicker>
                  </FormItem>
                  </Col> -->
                  <!-- <Col span="10">
                    <FormItem :label="$t('chargeStationImages.field.tenant_key')" name="tenantKey">
                                            <Input :placeholder="$t('chargeStationImages.validate.required.tenant_key')"
                                                   v-model:value="form.tenantKey">
                                            </Input>
                  </FormItem>
                  </Col> -->
                <!--判断是否有子表，如果有则直接加入子表管理逻辑-->
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>

<script>
import {
  Modal,
  Row,
  Col,
  Form,
  Input,
  InputNumber,
  Image,
  Radio,
  Steps,
  Step,
  Button,
  message,
  Select,
  DatePicker,
  InputGroup,
  Upload,
  Descriptions,
  DescriptionsItem,
  Space,
  Card,
  Table,
  Popconfirm,
} from "ant-design-vue";
import {
  UploadOutlined,
  UserOutlined,
  SolutionOutlined,
  FileImageOutlined,
  CheckOutlined,
  PlusOutlined,
  MinusCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
import { ChargeStationImagesAdd, ChargeStationImagesEdit } from "@/api/chargeStationImages";
import { ChargingStationListAll } from "@/api/chargingStation"
import UploadImage from "@/components/Common/UploadImage"

import { GetUrl } from "@/api/common";

export default {
  name: "ChargeStationImagesEdit",
  components: {
    Modal,
    Row,
    Col,
    UserOutlined,
    SolutionOutlined,
    FileImageOutlined,
    CheckOutlined,
    UploadOutlined,
    PlusOutlined,
    MinusCircleOutlined,
    ExclamationCircleOutlined,
    Form: Form,
    FormItem: Form.Item,
    Input: Input,
    InputPassword: Input.Password,
    Textarea:Input.TextArea,
    InputGroup,
    InputNumber,
    Image,
    RadioGroup: Radio.Group,
    RadioButton: Radio.Button,
    Steps,
    Step,
    Button,
    message,
    Select,
    SelectOption: Select.Option,
    DatePicker,
    Upload,
    UploadImage,
    Descriptions,
    DescriptionsItem,
    Space,
    Card,
    Table,
    Popconfirm,
  },
  data() {
    return {
      visible: false,
      actionType: "",
      form: {
        idIma : undefined,
        idChaPoi : undefined,
        url : undefined,
        uploadTime : undefined,
        tenantKey : undefined,
      },
      fileList: {
      },
      selectList: {
        chargingStationList: [],
      },
      validateRules: {
        idIma: [
          {
            required: true,
            message: this.$t("chargeStationImages.validate.required.id_ima"),
            trigger: "change",
            type: "number",
          },
        ],
        idChaPoi: [
          {
            required: true,
            message: this.$t("chargeStationImages.validate.required.id_cha_poi"),
            trigger: "change",
            type: "number",
          },
        ],
        url: [
          {
            required: true,
            message: this.$t("chargeStationImages.validate.required.url"),
            trigger: "change",
          },
        ],
        uploadTime: [
          {
            required: true,
            message: this.$t("chargeStationImages.validate.required.upload_time"),
            trigger: "change",
          },
        ],
        tenantKey: [
          {
            required: true,
            message: this.$t("chargeStationImages.validate.required.tenant_key"),
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    title: function () {
      let name = "";
      switch (this.actionType) {
        case "add":
          name = this.$t("public.name.add");
          break;
        case "edit":
          name = this.$t("public.name.edit");
          break;
      }
      return name;
    },
  },
  watch: {
      "visible": {
          deep: true,
          handler: function (newValue, oldValue) {
              if (!newValue) {
                  this.$emit("updateList");
              }
          }
      }
  },
  mounted() {
  },
  methods: {
    addShow() {
      this.actionType = "add";
      this._resetData();
      this.getChargingStationList();
      if (this.$refs.upload_url) {
          this.$refs.upload_url.change_url("")
      }
      this.visible = true;
    },
    editShow(obj) {
      this._resetData();
      // if (this.$refs.upload_url) {
      //   this.$refs.upload_url.change_url("")
      // }
      this.actionType = "edit";
      this.form = JSON.parse(JSON.stringify(obj));
      this.getChargingStationList();

      this.visible = true;
    },
    submit() {
      this.$refs["chargeStationImagesForm"]
        .validate()
        .then(() => {
          let api;
          switch (this.actionType) {
            case "add":
              console.log("add");
              api = new ChargeStationImagesAdd();
              break;
            case "edit":
              console.log("edit");
              api = new ChargeStationImagesEdit();
              break;
            default:
              return false;
          }
          api.post(this.form).then((response, any) => {
            if (0 === parseInt(response.data.code)) {
              message.success(this.$t("succeedMsg.0"));
              this.$emit("updateList",response.data.data);
              this.visible = false;
            } else {
              if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
            }
          });
        })
        .catch(() => {
        });
    },
    getChargingStationList() {
      const api = new ChargingStationListAll();
      api.get().then((response) => {
        if (0 === parseInt(response.data.code)) {
            this.selectList.chargingStationList = response.data.data;
        } else {
            if(response.data.code !== undefined){message.error(this.$t("errorMsg." + response.data.code));}
        }
      });
    },
    // reset data
    _resetData() {
      this.form = {
        idIma : undefined,
        idChaPoi : undefined,
        url : undefined,
        uploadTime : undefined,
        tenantKey : undefined,
      };
    },
  },
};
</script>

<style lang="less">
</style>
